<template>
  <nav>
    <v-fab-transition>
      <v-btn
        :to="link.route"        
        :color="color"
        right
        bottom
        fab
        large
        :class="classes" 
        style="z-index= 1;position: fixed; bottom: 20px;right: 10px;" 
        data-testid="edit-button"
        @click.stop="activateDialog"
        class="edit-button"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
  </nav>
</template>

<script>
export default {
  props: {
    link: {
      type: Object,
      default: () => {}
    },
    classes: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'accent'
    }
  }
}
</script>